import { projectList } from "constants/project";

const initialState = {
  projectList: {},
};

const project = (state = initialState, action) => {
  switch (action.type) {
    case projectList:
      return { ...state, projectList: action.payload };

    default:
      return state;
  }
};
export default project;
